import React, { Fragment, useEffect } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Bg from "../../images/bg/page_bg01.jpg";
import { useNavigate } from "react-router-dom";
import Downloadfooter from "../../components/footer/Downloadfooter";

const ReferAndEarnPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* FAQs */
  const referralFaqs = [
    {
      q: "1. Where can I find my referral link or referral code?",
      a: "Once you log in to the app, tap on the Profile icon. In Profile Settings, select Refer & Earn, where you’ll find your referral link and referral code.",
    },
    {
      q: "2. How does the Refer & Earn offer work?",
      a: "Invite a friend using your referral link or code. Once they complete a qualifying transfer, you earn a reward.",
    },
    {
      q: "3. What is a qualifying transfer?",
      a: "A qualifying transfer is a single transaction of £250 or more.",
    },
    {
      q: "4. What reward will I receive?",
      a: "You will receive £5 credited directly to your wallet.",
    },
    {
      q: "5. Will I earn £5 on every transfer?",
      a: "No, the reward is applicable only for your friend’s first qualifying transfer.",
    },
    {
      q: "6. When will the £5 be credited?",
      a: "The reward is credited shortly after the qualifying transfer is completed.",
    },
  ];

  /* TERMS */
  const terms = [
    "The programme is available to all registered users with an active account.",
    "Referrals must be made using your unique referral link or code.",
    "The referred user must complete a £250 transfer in a single transaction.",
    "The reward is credited only once per referred user.",
    "The reward is non-withdrawable and can be used for future transfer fees.",
    "Misuse or self-referrals may result in disqualification.",
    "The company reserves the right to amend the programme at any time.",
  ];

  const steps = [
    {
      step: "01",
      title: "Invite Your Friend",
      desc: "Share your referral link or code via WhatsApp, email, or any platform.",
      icon: "/images/icons/1.png",
    },
    {
      step: "02",
      title: "Friend Sends Money",
      desc: "Your friend completes a £250 or more transfer in one transaction.",
      icon: "/images/icons/2.png",
    },
    {
      step: "03",
      title: "Earn £5",
      desc: "Once completed, £5 is credited instantly to your wallet.",
      icon: "/images/icons/3.png",
    },
  ];

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />

        {/* HERO */}
        {/* <section
          className="page-title pt-120 md:pt-30 text-center bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <h2 className="title text-dark">Refer & Earn</h2>
        </section> */}

        {/* BANNER */}
        <section className="pt-80 pb-80 bg-light">
          <div className="container text-center mt-5">
            <img
              src="/images/icons/refer-earn-banner.png"
              alt="Refer and Earn Banner"
              className="img-fluid"
              style={{
                borderRadius: "20px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                maxWidth: "100%",
                height: "auto"
              }}
            />
          </div>
        </section>

        {/* STATS */}
        <section className="pb-4 mt-5">
          <div className="container">
            <div className="row text-center">
              {[
                { label: "Reward", value: "£5" },
                { label: "Minimum Transfer", value: "£250" },
                { label: "Payout Speed", value: "Instant" },
                { label: "Referral Limit", value: "Unlimited" },
              ].map((item, i) => (
                <div key={i} className="col-lg-3 col-md-6 mb-4">
                  <div
                    className="stat-card h-100"
                    style={{
                      background: "#ffffff",
                      borderRadius: "20px",
                      padding: "30px",
                      boxShadow: "0 10px 40px rgba(0,0,0,0.06)",
                      border: "1px solid rgba(0,0,0,0.02)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.06)";
                    }}
                  >
                    <div style={{
                      position: 'absolute',
                      top: '-30px',
                      right: '-30px',
                      width: '80px',
                      height: '80px',
                      background: 'linear-gradient(135deg, rgba(255,204,41,0.2) 0%, rgba(255,255,255,0) 70%)',
                      borderRadius: '50%'
                    }}></div>

                    <h3 className="fw-bold mb-2" style={{ fontSize: '36px', color: '#2c3e50' }}>{item.value}</h3>
                    <p className="mb-0 text-muted fw-bold" style={{ letterSpacing: '1px', textTransform: 'uppercase', fontSize: '12px' }}>{item.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* INTRO */}
        <section className="pt-0 mt-0 pb-80 bg-white">
          <div className="container text-center">
            <h2 className="xb-title mb-3">How It Works</h2>
            <p className="text-muted fs-5">
              Invite friends and earn rewards when they make a qualifying transfer.
            </p>
          </div>
        </section>
        {/* STEPS */}
        <section className="pb-10">
          <div className="container">
            <div className="row justify-content-center">
              {steps.map((item, i) => (
                <div key={i} className="col-lg-4 col-md-6 mb-4">
                  <div
                    className="step-card h-100 text-center position-relative"
                    style={{
                      padding: "40px 30px",
                      background: "#ffffff",
                      borderRadius: "24px",
                      boxShadow: "0 15px 50px rgba(0,0,0,0.05)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      border: "1px solid rgba(0,0,0,0.01)",
                      overflow: "hidden"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow = "0 25px 60px rgba(0,0,0,0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.05)";
                    }}
                  >
                    {/* Decorative Blob */}
                    <div style={{
                      position: 'absolute',
                      top: '-50px',
                      right: '-50px',
                      width: '150px',
                      height: '150px',
                      background: 'radial-gradient(circle, rgba(255,204,41,0.15) 0%, rgba(255,255,255,0) 70%)',
                      borderRadius: '50%',
                      zIndex: 0
                    }}></div>

                    <div className="icon-box mb-4 position-relative" style={{ zIndex: 1, minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{ width: "120px", height: "auto", objectFit: 'contain', filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))' }}
                      />
                    </div>

                    <div className="step-badge d-inline-block mb-3" style={{
                      background: 'rgba(255, 204, 41, 0.15)',
                      color: '#d4a000',
                      padding: '6px 16px',
                      borderRadius: '30px',
                      fontSize: '13px',
                      fontWeight: '700',
                      letterSpacing: '1px'
                    }}>
                      STEP {item.step}
                    </div>

                    <h3 className="mb-3 fw-bold" style={{ fontSize: '22px' }}>{item.title}</h3>

                    <p className="text-muted mb-0" style={{ lineHeight: '1.7' }}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>



        {/* FAQ & TERMS */}
        <section className="pt-10 pb-50 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <h2 className="xb-title text-center mb-5">
                Additional Information
              </h2>
              <div className="col-lg-10">
                {/* FAQs Section */}
                <div className="mb-4">
                  <h4 className="fw-bold text-dark mb-4">Refer & Earn – FAQs</h4>
                  <div className="accordion" id="referFaqAccordion">
                    {referralFaqs.map((item, i) => (
                      <div className="accordion-item mb-3" key={i}>
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target={`#refer-faq-${i}`}
                          >
                            {item.q}
                          </button>
                        </h2>
                        <div
                          id={`refer-faq-${i}`}
                          className="accordion-collapse collapse"
                          data-bs-parent="#referFaqAccordion"
                        >
                          <div className="accordion-body">
                            <p className="text-muted mb-0">{item.a}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Terms Section */}
        <section className="pb-100 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="mb-4">
                  <h4 className="fw-bold text-dark mb-4">Refer & Earn – Terms & Conditions</h4>
                  <div className="accordion" id="referTermsAccordion">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed fw-bold"
                          data-bs-toggle="collapse"
                          data-bs-target="#terms"
                        >
                          Click to view Terms & Conditions
                        </button>
                      </h2>
                      <div
                        id="terms"
                        className="accordion-collapse collapse"
                        data-bs-parent="#referTermsAccordion"
                      >
                        <div className="accordion-body">
                          <ol>
                            {terms.map((item, i) => (
                              <li key={i} className="mb-2">
                                {item}
                              </li>
                            ))}
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Downloadfooter />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default ReferAndEarnPage;
